const ROLES = ["subowner", "player", "audience", "denied"] as const;

export type Role = typeof ROLES[number];

export type MessageTabOrder = {
  _id?: string;
  messageTabGroups: string[];
};

export type UpdateMessageTabOrder = Partial<MessageTabOrder>;

export const MessageTabOrderRecord = (
  messageTabOrder: UpdateMessageTabOrder
): MessageTabOrder => {
  return {
    messageTabGroups: messageTabOrder.messageTabGroups || [],
  };
};
